<!-- Calendly inline widget begin -->
<!-- <div class="calendly-inline-widget" style="min-width:320px;height:700px;"
    data-url="https://calendly.com/arathod-rdglobalinc/30-minute-meeting-clone?email={{userReg.email}}&name={{userReg.firstName}} {{userReg.lastName}}"></div> -->
<!-- Calendly inline widget end -->

<div class="calendly-inline-widget" style="min-width:320px;height:700px;" data-auto-load="false"></div>

<app-footer></app-footer>
